/**
 * Rendering backend to do nothing in nodejs.
 */
"use strict";

exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VirtualRenderer = (function () {
  function VirtualRenderer() {
    _classCallCheck(this, VirtualRenderer);
  }

  VirtualRenderer.style = function style() {};

  VirtualRenderer.prototype.attach = function attach() {};

  VirtualRenderer.prototype.detach = function detach() {};

  VirtualRenderer.prototype.deploy = function deploy() {};

  VirtualRenderer.prototype.insertRule = function insertRule() {};

  VirtualRenderer.prototype.getRules = function getRules() {
    return {};
  };

  return VirtualRenderer;
})();

exports["default"] = VirtualRenderer;
module.exports = exports["default"];